import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { catchError, finalize, map, tap, takeUntil } from "rxjs/operators";
import { MatAutocomplete, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatChipList } from '@angular/material/chips';
import { CampaignsService } from 'src/app/pages/campaign-module/campaigns/campaigns.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { LanguageService, DialogService, HelperService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { of as observableOf, fromEvent } from 'rxjs';
import { PsrService } from '../psr.service';
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'esc-psr-filter',
  templateUrl: './psr-filter.component.html',
  styleUrls: ['./psr-filter.component.scss']
})
export class PsrFilterComponent implements OnInit {
  @Output() generateReport = new EventEmitter();

  @ViewChild('chainAC') chainACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) chainACTr: MatAutocompleteTrigger;

  @ViewChild('chipsIslandGroup') chipsIslandGroup: MatChipList;
  @ViewChild('island_groupAC') islGrpACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) islGrpACTr: MatAutocompleteTrigger;

  @ViewChild('chipsRegion') chipsRegion: MatChipList;
  @ViewChild('regionAC') regionACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) regionACTr: MatAutocompleteTrigger;

  @ViewChild('chipsProvince') chipsProvince: MatChipList;
  @ViewChild('provinceAC') provinceACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) provinceACTr: MatAutocompleteTrigger;

  @ViewChild('cityProvince') cityProvince: MatChipList;
  @ViewChild('cityAC') cityACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) cityACTr: MatAutocompleteTrigger;

  @ViewChild('chipsTerritory') chipsTerritory: MatChipList;
  @ViewChild('territoryAC') territoryACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) territoryACTr: MatAutocompleteTrigger;

  @ViewChild('chipsCampaign') chipsCampaign: MatChipList;
  @ViewChild('campaignAC') campaignACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) campaignACTr: MatAutocompleteTrigger;

  @ViewChild('chipsDistribution') chipsDistribution: MatChipList;
  @ViewChild('distributionAC') distributionACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) distributionACTr: MatAutocompleteTrigger;

  @ViewChild('chipsCategory') chipsCategory: MatChipList;
  @ViewChild('categoryAC') categoryACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) categoryACTr: MatAutocompleteTrigger;

  @ViewChild('chipsBrand') chipsBrand: MatChipList;
  @ViewChild('brandAC') brandACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) brandACTr: MatAutocompleteTrigger;

  @ViewChild('chipsItem') chipsItem: MatChipList;
  @ViewChild('itemAC') itemACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) itemACTr: MatAutocompleteTrigger;

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    public campSvc: CampaignsService,
    private dialogService: DialogService,
    private service: PsrService,
    private languageService: LanguageService,
    public helper: HelperService
  ) { }

  public defaultOption = {
    id: 0,
    code: "all",
    description: "All"
  };
  public loading = {
    chain: false,
    island_group: false,
    region: false,
    province: false,
    city: false,
    territory: false,
    campaign: false,
    distribution: false,
    category: false,
    brand: false,
    item: false,
    error: false
  };

  chains = [];
  island_groups = [];
  island_group_ids = []
  regions = [];
  region_ids = []
  provinces = [];
  province_ids = [];
  cities = [];
  city_ids = []
  territories = [];
  campaigns = [];
  campaign_ids = [];
  distributions = [];
  distribution_ids = [];
  categories = [];
  category_ids = []
  brands = [];
  brand_ids = []
  items = [];
  item_ids = []

  filterOptions = {
    island_group: [],
    region: [],
    province: [],
    city: [],
    territory: [],
    campaign: [],
    distribution: [],
    category: [],
    brand: [],
    item: []
  }

  multiSelect = {
    selectedIslandGroups: [this.defaultOption],
    selectedRegions: [this.defaultOption],
    selectedProvinces: [this.defaultOption],
    selectedCities: [this.defaultOption],
    selectedTerritories: [this.defaultOption],
    selectedCampaigns: [this.defaultOption],
    selectedDistributions: [this.defaultOption],
    selectedCategories: [this.defaultOption],
    selectedBrands: [this.defaultOption],
    selectedItems: [this.defaultOption],
  };
  
  data;
  defaultStartDate = moment().toDate();
  defaultEndDate = moment().toDate();
  public filters;
  public formGroup: FormGroup;
  networkErrMsg = this.languageService.getTranslation("MESSAGE_ERROR_NETWORK_CONNECTION", {});

  ngOnInit() {
    this.initForm();
    this.detectFormChanges();
  }

  initForm() {
    this.formGroup = this.fb.group({
      settlement_start_date: [_.get(this.data, 'settlement_start_date'), Validators.required],
      settlement_end_date: [_.get(this.data, 'settlement_end_date'), Validators.required],
      chain: [_.get(this.data, 'chain'), Validators.required],
      island_group: [_.get(this.data, 'island_group') || 0],
      region: [_.get(this.data, 'region') || 0],
      province: [_.get(this.data, 'province') || 0],
      city: [_.get(this.data, 'city') || 0],
      territory: [_.get(this.data, 'territory') || 0],
      campaign: [_.get(this.data, 'campaign') || 0],
      distribution: [_.get(this.data, 'distribution') || 0],
      category: [_.get(this.data, 'category') || 0],
      brand: [_.get(this.data, 'brand') || 0],
      item: [_.get(this.data, 'sku') || 0]
    })
  }

  detectFormChanges() {
    this.formGroup.get('settlement_start_date').valueChanges.subscribe(value => {
      if (value) {
        this.formGroup.get('settlement_end_date').reset();
        this.formGroup.get('settlement_end_date').markAsTouched();
      }
      else {
        this.formGroup.get('settlement_end_date').reset();
        this.formGroup.get('settlement_end_date').markAsPristine();
      }
    });

    this.formGroup.get('chain').valueChanges.subscribe(value => {
      this.formGroup.get('island_group').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('region').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('province').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('city').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('territory').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('campaign').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('distribution').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('category').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('brand').setValue(this.defaultOption, { emitEvent: false });
      this.formGroup.get('item').setValue(this.defaultOption, { emitEvent: false });

      //display "All" in chips
      for (let prop in this.multiSelect) {
        this.multiSelect[prop] = [this.defaultOption];
      }
    })
  }

  getInitialData(name) {
    this.autoCmpltClosed(name);
    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.getData(name);
  }

  getMoreData(name) {
    if (this.filters.getMore) {
      this.filters.web_filter.offset += INITIAL_OPTIONS.web_filter.limit;
      this.getData(name);
    }
  }

  handleFilterResponse(res,filterName,filters, selectedArrayGroup){
    this.loading[filterName] = false;
    if (environment.showLogs) {
      console.log(res);
    }
    if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
      this.loading.error = true;
      this.dialogService.openSnackBar(this.networkErrMsg)
      return;
    }
    if (_.has(res, 'value') && (res.value == "Success")) {
      if (!filters.web_filter.keyword) {
        this.filterOptions[filterName][0] = this.defaultOption;
      }

      this.filterOptions[filterName] = this.filterOptions[filterName].concat(res.data);
      this.checkSelected(filterName, selectedArrayGroup, filterName);
      // for (var island_group of this.island_groups) {
      //   this.island_group_ids = this.island_group_ids.concat(island_group.id)
      // }

      if ((res.data.length > 0) && (this.filterOptions[filterName].length < _.get(res, 'count'))) {
        this.filters.getMore = true;
      }
    }
  }

  getData(name) {
    let filters = _.cloneDeep(this.filters)
    this.filters.getMore = false;
    this.loading[name] = true;

    switch (name) {
      case "chain": {
        this.chains = [];
        filters.web_filter["chain_type_ids"] = [0];
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = 0
        filters.web_filter.filters["island_group_id"] = [0]
        filters.web_filter.filters["region_id"] = [0]
        filters.web_filter.filters["province_id"] = [0]
        filters.web_filter.filters["city_id"] = [0]
        filters.web_filter.filters["campaign_id"] = [0]
        filters.web_filter.filters["territory_id"] = [0]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "chain"
        this.service.filter(filters).pipe(
          tap(() => this.loading.chain = true),
          finalize(() => {
            this.loading.chain = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.chain = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.chain = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.loading.error = true;

              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              this.chains = this.chains.concat(res.data);

              if ((res.data.length > 0) && (this.chains.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
        break;
      }
      case "island_group": {
        this.filterOptions['island_group'] = [];
        this.island_group_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value["id"] || 0
        filters.web_filter.filters["island_group_id"] = [0]
        filters.web_filter.filters["region_id"] = [0]
        filters.web_filter.filters["province_id"] = [0]
        filters.web_filter.filters["city_id"] = [0]
        filters.web_filter.filters["campaign_id"] = [0]
        filters.web_filter.filters["territory_id"] = [0]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "island_group"
        this.service.filter(filters).pipe(
          tap(() => this.loading.island_group = true),
          finalize(() => {
            this.loading.island_group = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.island_group = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'island_group',filters,'selectedIslandGroups')
          });
        break;
      }
      case "region": {
        this.regions = [];
        this.region_ids = [];

        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = [0]
        filters.web_filter.filters["province_id"] = [0]
        filters.web_filter.filters["city_id"] = [0]
        filters.web_filter.filters["territory_id"] = [0]
        filters.web_filter.filters["campaign_id"] = [0]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "region"
        this.service.filter(filters).pipe(
          tap(() => this.loading.region = true),
          finalize(() => {
            this.loading.region = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.region = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            
            this.handleFilterResponse(res,'region',filters,'selectedRegions')
          });
        break;
      }
      case "province": {
        this.provinces = [];
        this.province_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = [0]
        filters.web_filter.filters["city_id"] = [0]
        filters.web_filter.filters["territory_id"] = [0]
        filters.web_filter.filters["campaign_id"] = [0]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "province"
        this.service.filter(filters).pipe(
          tap(() => this.loading.province = true),
          finalize(() => {
            this.loading.province = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.province = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'province',filters,'selectedProvinces')
          });
        break;
      }

      case "city": {
        this.cities = [];
        this.city_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = this.helper.reportFilterGet(this.formGroup.get("province").value, [0])
        filters.web_filter.filters["city_id"] = [0]
        filters.web_filter.filters["territory_id"] = [0]
        filters.web_filter.filters["campaign_id"] = [0]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "city"
        this.service.filter(filters).pipe(
          tap(() => this.loading.city = true),
          finalize(() => {
            this.loading.city = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.city = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'city',filters,'selectedCities')
          });
        break;
      }

      case "campaign": {
        this.campaigns = [];
        this.campaign_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = this.helper.reportFilterGet(this.formGroup.get("province").value, [0])
        filters.web_filter.filters["city_id"] = this.helper.reportFilterGet(this.formGroup.get("city").value, [0])
        filters.web_filter.filters["territory_id"] = [0]
        filters.web_filter.filters["campaign_id"] = [0]
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "campaign"
        this.service.filter(filters).pipe(
          tap(() => this.loading.campaign = true),
          finalize(() => {
            this.loading.campaign = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.campaign = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'campaign',filters,'selectedCampaigns')
          });
        break;
      }

      case "distribution": {
        this.distributions = [];
        this.distribution_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = this.helper.reportFilterGet(this.formGroup.get("province").value, [0])
        filters.web_filter.filters["city_id"] = this.helper.reportFilterGet(this.formGroup.get("city").value, [0])
        filters.web_filter.filters["campaign_id"] = this.helper.reportFilterGet(this.formGroup.get("campaign").value, [0])
        filters.web_filter.filters["distribution_id"] = [0]
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "distribution"
        this.service.filter(filters).pipe(
          tap(() => this.loading.distribution = true),
          finalize(() => {
            this.loading.distribution = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.distribution = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'distribution',filters,'selectedDistributions')
          });
        break;
      }

      case "category": {
        this.categories = [];
        this.category_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = this.helper.reportFilterGet(this.formGroup.get("province").value, [0])
        filters.web_filter.filters["city_id"] = this.helper.reportFilterGet(this.formGroup.get("city").value, [0])
        filters.web_filter.filters["campaign_id"] = this.helper.reportFilterGet(this.formGroup.get("campaign").value, [0])
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0])
        filters.web_filter.filters["category_id"] = [0]
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "category"
        this.service.filter(filters).pipe(
          tap(() => this.loading.category = true),
          finalize(() => {
            this.loading.category = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.category = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'category',filters,'selectedCategories')
          });
        break;
      }


      case "brand": {
        this.brands = [];
        this.brand_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = this.helper.reportFilterGet(this.formGroup.get("province").value, [0])
        filters.web_filter.filters["city_id"] = this.helper.reportFilterGet(this.formGroup.get("city").value, [0])
        filters.web_filter.filters["campaign_id"] = this.helper.reportFilterGet(this.formGroup.get("campaign").value, [0])
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0])
        filters.web_filter.filters["category_id"] = this.helper.reportFilterGet(this.formGroup.get("category").value, [0])
        filters.web_filter.filters["brand_id"] = [0]
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "brand"
        this.service.filter(filters).pipe(
          tap(() => this.loading.brand = true),
          finalize(() => {
            this.loading.brand = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.brand = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'brand',filters,'selectedBrands')
          });
        break;
      }

      case "item": {
        this.items = [];
        this.item_ids = []
        filters.web_filter.filters["start_date"] = moment(this.formGroup.get("settlement_start_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["end_date"] = moment(this.formGroup.get("settlement_end_date").value).format("YYYY-MM-DD")
        filters.web_filter.filters["chain_id"] = this.formGroup.get("chain").value['id'] || 0
        filters.web_filter.filters["island_group_id"] = this.helper.reportFilterGet(this.formGroup.get("island_group").value, [0])
        filters.web_filter.filters["region_id"] = this.helper.reportFilterGet(this.formGroup.get("region").value, [0])
        filters.web_filter.filters["province_id"] = this.helper.reportFilterGet(this.formGroup.get("province").value, [0])
        filters.web_filter.filters["city_id"] = this.helper.reportFilterGet(this.formGroup.get("city").value, [0])
        filters.web_filter.filters["campaign_id"] = this.helper.reportFilterGet(this.formGroup.get("campaign").value, [0])
        filters.web_filter.filters["distribution_id"] = this.helper.reportFilterGet(this.formGroup.get("distribution").value, [0])
        filters.web_filter.filters["category_id"] = this.helper.reportFilterGet(this.formGroup.get("category").value, [0])
        filters.web_filter.filters["brand_id"] = this.helper.reportFilterGet(this.formGroup.get("brand").value, [0])
        filters.web_filter.filters["product_id"] = [0]
        filters.web_filter["filter_type"] = "product"
        this.service.filter(filters).pipe(
          tap(() => this.loading.item = true),
          finalize(() => {
            this.loading.item = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.item = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.handleFilterResponse(res,'item',filters,'selectedItems')
          });
        break;
      }
    }
  }

  autoCmpltClosed(name) {
    let options = (name != 'branch') ? (name + "s") : (name + "es");
    this.filterOptions[name] = [];
  }

  resetControl(control: FormControl) {
    control.reset(null, { emitEvent: false });
  }

  displayFn(data?: any): string | undefined {
    return data ? _.get(data, 'description') : null;
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              this.getMoreData(name);
            }
          });
      }
    });
  }

  applyFilters() {
    for (let ctrl in this.formGroup.controls) {
      if (!this.formGroup.controls[ctrl].valid) {
        this.formGroup.controls[ctrl].markAsTouched();
      }
    }
    if (this.formGroup.valid) {
      this.generateReport.next(this.formGroup.value);
    }
  }

  checkAutocompleteObject(control, objectKey, targetArray) {
    if ((!_.isObject(control.controls[objectKey].value) || control.controls[objectKey].value.id == null) && control.controls[objectKey].value != "") {
      control.controls[objectKey].setErrors({
        "notExisting": true
      });
    }

    if (_.size(this[targetArray]) && targetArray) {
      control.controls[objectKey].setValue(null);
      this.assignFormValues(targetArray, objectKey);
    }
  }

  optionClicked(event: Event, data, srcArray, targetArray, formControlName, inputElem) {
    event.stopPropagation();
    this.toggleSelection(data, srcArray, targetArray, formControlName, inputElem);
  }

  toggleSelection(data, srcArray, targetArray, formControlName, inputElem) {
    if (inputElem) {
      inputElem.value = '';
    }
    data.selected = !data.selected;

    //if 'all' is selected, choose only all
    if (data.selected == true && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = true;
      });
      this.multiSelect[targetArray] = [];
      this.multiSelect[targetArray].push(data);
      this.disableCheckbox(srcArray, formControlName, data);
    }

    //if 'all' is deselected, unselect everything
    else if (data.selected == false && data.code == 'all') {
      srcArray.forEach(e => {
        e.selected = false;
      });
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      this.enableCheckbox(srcArray);
    }

    else if (this.multiSelect[targetArray].indexOf(data) == -1) {
      //if other option is selected, check if 'all' is already selected and clear selection
      // this.multiSelect[targetArray].some(opt => opt.code == data.code)
      if (this.multiSelect[targetArray].indexOf(this.defaultOption) > -1) {
        srcArray.forEach(e => {
          e.selected = false;
        });
        this.multiSelect[targetArray] = [];
      }
      //if data exists in array, remove from list
      else if (this.multiSelect[targetArray].some(opt => opt.code == data.code)) {
        let index = _.findIndex(this.multiSelect[targetArray], function (item) { return item['code'] == data.code })
        this.multiSelect[targetArray].splice(index, 1);
      }
      else {
        this.multiSelect[targetArray].push(data);
      }
    }

    else {
      this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(data), 1);
      srcArray.forEach(e => {
        if (e.id == data.id) {
          e.selected = false;
        }
      });
    }
    this.assignFormValues(targetArray, formControlName);
  }

  enableCheckbox(optionArray) {
    optionArray.forEach(e => {
      e.disabled = false;
    })
  }

  disableCheckbox(optionArray, formControlName, data) {
    if (optionArray[0].selected && (_.has(this.formGroup.get(formControlName), 'value') && this.formGroup.get(formControlName).value == 0) || (_.get(data, 'code') == 'all')) {
      optionArray.forEach(e => {
        if (e.code != 'all') {
          e.disabled = true;
        }
      })
    } else {
      this.enableCheckbox(optionArray);
    }
  }

  assignFormValues(targetArray, formControlName) {
    let tempArr;
    if ((formControlName != 'location_region') && (formControlName != 'location_province') && (formControlName != 'location_city')) {
      tempArr = this.multiSelect[targetArray].map(e => {
        return e.id;
      });

    } else {
      tempArr = this.multiSelect[targetArray].map(e => {
        let obj = {
          code: e.code,
          description: e.description
        }
        return obj;
      });
    }
    let val = _.cloneDeep(tempArr)
    this.formGroup.controls[formControlName].patchValue(val); 
  }

  checkSelected(srcArray, targetArray, formControlName) {
    if (this.multiSelect[targetArray].some(opt => opt.description == 'All')) {
      let tempObj = _.cloneDeep(this.defaultOption);
      tempObj['selected'] = false;
      this.toggleSelection(tempObj, this.filterOptions[srcArray], targetArray, formControlName, null);
    }
    else if (this.multiSelect[targetArray].length) {
      this.filterOptions[srcArray].forEach(e => {
        this.multiSelect[targetArray].forEach(v => {
          if (e.description == v.description) {
            e.selected = v.selected;
          }
        })
        if (e.description == 'All') {
          e.selected = false;
        }
      })
    } else {
      this[srcArray].forEach(e => {
        e.selected = false;
      })
    }
  }

  reset() {
    for (let ctrl in this.formGroup.controls) {
      this.formGroup.controls[ctrl].reset(null, { emitEvent: false });
      this.formGroup.controls[ctrl].setValue(null, { emitEvent: false });
      this.formGroup.controls[ctrl].markAsUntouched();
    }

    this.formGroup.get('island_group').setValue(this.defaultOption);
    this.formGroup.get('region').setValue(this.defaultOption);
    this.formGroup.get('province').setValue(this.defaultOption);
    this.formGroup.get('city').setValue(this.defaultOption);
    this.formGroup.get('territory').setValue(this.defaultOption);
    this.formGroup.get('campaign').setValue(this.defaultOption);
    this.formGroup.get('distribution').setValue(this.defaultOption);
    this.formGroup.get('category').setValue(this.defaultOption);
    this.formGroup.get('brand').setValue(this.defaultOption);
    this.formGroup.get('item').setValue(this.defaultOption);


    for (let prop in this.multiSelect) {
      // console.log(prop);
      this.multiSelect[prop] = [this.defaultOption];
    }
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    offset: 0,
    limit: 50,
    keyword: "",
    getMore: true,
    filter_type: "",
    filters: {
      start_date: "",
      end_date: "",
      chain_id: 0,
      island_group_id: [],
      region_id: [],
      province_id: [],
      city_id: [],
      campaign_id: [],
      distribution_id: [],
      category_id: [],
      brand_id: [],
      product_id: []
    }
  }
}